import * as React from 'react';
import { FormComponentProps } from '../../form/Form';
import { FormGroup } from '../../form/FormGroup';
import { FormInput } from '../../form/FormInput';
import { FormTextArea } from '../../form/FormTextArea';
import { FormTransferContainer } from '../../form/FormTransferContainer';
import { Validators } from '../../form/Validators';

export class TournamentInfoPanel extends React.Component<FormComponentProps, {}> {

    render() {
        return (
            <FormTransferContainer {...this.props}>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='ibox float-e-margins'>
                            <div className='ibox-title'>
                                <h5>Tournament Info</h5>
                            </div>
                            <div className='ibox-content'>
                                <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label '>Name</label>
                                    <div className='col-sm-10'>
                                        <FormInput model='configuration.name' type='text' className='form-control name'
                                                   validators={[Validators.required()]}/>
                                    </div>
                                </FormGroup>
                                <div className='hr-line-dashed'></div>
                                <div className='form-group'>
                                    <label className='col-sm-2 control-label'>Description</label>
                                    <div className='col-sm-10'>
                                        <FormTextArea model='configuration.description' className='form-control'/>
                                    </div>
                                </div>
                                <div className='hr-line-dashed'></div>
                                <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label'>Tags</label>
                                    <div className='col-sm-10'>
                                        <FormInput model='configuration.tags' type='text' className='form-control'/>
                                        <span className='help-block m-b-none'>
                                            Can be used to have specific backgrounds for certain tables,
                                            tags will be appended to table container as CSS-classes.
                                            If tags starts with // it will be set as background: background-image :
                                            url("//test.com/image.png")
                                        </span>
                                    </div>
                                </FormGroup>
                                <div className='hr-line-dashed'></div>
                            </div>
                        </div>
                    </div>
                </div>
            </FormTransferContainer>
        );

    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/TournamentInfoPanel.tsx